import React, { useRef, useState, useEffect } from "react";
import { Button, Pagination, Tooltip, Whisper } from "rsuite";
import "./opportunities.scss";
import { numberFormatter } from "../../utils";
import InfoOutlineIcon from "@rsuite/icons/InfoOutline";
import GrossMarginChart1 from "./grossMarginChart1";
import GrossMarginChart2 from "./grossMarginChart2";
import FileDownloadIcon from "@rsuite/icons/FileDownload";
import { CSVLink } from "react-csv";

const NiaPerformance = (props: any) => {
	const { selectedMaskStatus, supplier, selectedVendor } = props;
	const exportFullRef = useRef<any>(null);

	const formatData = (data: any[]) => {
		let finalData: any = [];
		data?.forEach((item) => {
			if (supplier?.includes(item?.peer_vendor_name)) {
				let obj = {
					peer_vendor_name: item?.peer_vendor_name,
					cagr: `${item.cagr.toFixed(2)}%`,
					gm: `${item.gm.toFixed(2)}%`,
					invCost: `$${Math.round(item.invCost)}`,
					rebate_base_lastyear: `${item.rebate_base_lastyear.toFixed(
						2
					)}%`,
					revenue: `$${Math.round(item.revenue)}`,
				};
				finalData.push(obj);
			}
		});
		return finalData;
		// return data.map(item => ( {
		//   ...item,
		//   cagr: `${item.cagr.toFixed(2)}%`,
		//   gm: `${item.gm.toFixed(2)}%`,
		//   invCost: `$${Math.round(item.invCost)}`,
		//   rebate_base_lastyear: `${item.rebate_base_lastyear.toFixed(2)}%`,
		//   revenue: `$${Math.round(item.revenue)}`
		// }));
	};

	const exportData = () => {
		if (props.exportDistrictData?.length !== 0) {
			exportFullRef?.current?.link.click();
		}
	};

	const csvHeaders = [
		{ label: "Master Vendor Name", key: "peer_vendor_name" },
		{ label: "CAGR", key: "cagr" },
		{ label: "Gross Margin", key: "gm" },
		{ label: "Spend", key: "invCost" },
		{ label: "Last Year NIA% of Spend", key: "rebate_base_lastyear" },
		{ label: "Revenue", key: "revenue" },
	];

	return (
		<div className="flex justify-center items-center h-full gap-x-[1vh]">
			<div className="w-full h-[78%] graphBox">
				<div className="headSpace">
					<div className="headContent">Gross Margin % Vs CAGR</div>
					<FileDownloadIcon
						className="text-fsre16"
						onClick={() => {
							exportData();
						}}
					/>
					<CSVLink
						ref={exportFullRef}
						data={formatData(props.performanceGraphData.peer)}
						headers={csvHeaders}
						filename="performance.csv"
						className="hidden"
						target="_blank"
					></CSVLink>
				</div>
				<GrossMarginChart1
					selectedVendor={selectedVendor}
					supplier={supplier}
					selectedMaskStatus={selectedMaskStatus}
					performanceGraphData={props.performanceGraphData}
				/>
			</div>
			<div className="w-full h-[78%] graphBox">
				<div className="headSpace">
					<div className="headContent">Gross Margin % vs NIA %​</div>
					<FileDownloadIcon
						className="text-fsre16"
						onClick={() => {
							exportData();
						}}
					/>
					<CSVLink
						ref={exportFullRef}
						data={formatData(props.performanceGraphData.peer)}
						headers={csvHeaders}
						filename="performance.csv"
						className="hidden"
						target="_blank"
					></CSVLink>
				</div>

				<GrossMarginChart2
					selectedVendor={selectedVendor}
					supplier={supplier}
					selectedMaskStatus={selectedMaskStatus}
					performanceGraphData={props.performanceGraphData}
				/>
			</div>
		</div>
	);
};

export default NiaPerformance;
